<template>
  <div>
    <div class="modal fade" id="routeInfoWindow" role="dialog" data-backdrop="static" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><img height="30px" src="@/assets/X.png"/></button>
              <h3 class="modal-title" id="myModalLabel" v-text="'ルート確認'"></h3>
          </div>
          <div class="modal-body">
            <div class="routeBody">
              <div class="routeInfo slider">
                <div class="detail" v-for='(item, i) in routerLists.routerList' :key='i'>
                  <!-- 圆圈 -->
                  <div class='radioClass'>
                      <!-- 圆圈里面的标记 -->
                      <template v-if='i === 0'>
                          <div class='tagClass'>
                              S
                          </div>
                      </template>
                      <template v-if='i && i !== 0 && i !== routerLists.routerList.length -1'>
                          <div class='tagClass'>
                              {{ `G${item.font}` }}
                          </div>
                      </template>
                      <template v-if='i === routerLists.routerList.length -1'>
                          <div class='tagClass'>
                              G
                          </div>
                      </template>
                  </div>
                  <!-- 竖线 -->
                  <!-- 第一个竖线 -->
                  <template v-if='i === 0'>
                      <div class='lineClassEnd line'></div>
                  </template>
                  <!-- 正常常规竖线 -->
                  <template v-if='i && i !== 0 && i !== routerLists.routerList.length -1'>
                      <div class='lineClass line'></div>
                  </template>
                  <!-- 最后一个竖线 -->
                  <template v-if='i === routerLists.routerList.length -1'>
                      <div class='lineClassFirst line'></div>
                  </template>
                  <div class='placeInfo-children-body'>
                      <div class='front' >
                          <span  style="text-align: left;white-space: nowrap;overflow: hidden;text-overflow: ellipsis">{{ item.address }}</span>
                      </div>
                  </div>
                </div>
              </div>
              <div class="googleMap">
                <google-map ref='gMap' :center-point='centerPo' :map-id='mapId' :point-list='routerLists.routerList'></google-map>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleMap from '@/components/googleMap'
import STATION_ICON from '@/assets/map_icon/map_stop_point1.png'
import STATION_ICON_FIRST from '@/assets/map_icon/map_transit_point1.png'
import { mapState } from 'vuex'
export default {
  props: {
    routeId: {
      type: String,
      default: ''
    }
  },
  components: {
    GoogleMap
  },
  computed: {
    ...mapState({
      routerLists: state => state.routerLists
    })
  },
  created () {
  },
  async mounted () {
  },
  data () {
    return {
      centerPo: { lat: 35.661041, lng: 139.87307 },
      mapId: 'routeInfoWinId',
      id: this.routeId
    }
  },
  methods: {
    async initGoogleMap () {
      await this.$refs.gMap.initializeGoogleMap()
      const routerList = this.routerLists.routerList
      const centerPoint = {
        lat: (routerList[0].stationLat + routerList[routerList.length - 1].stationLat) / 2,
        lng: (routerList[0].stationLng + routerList[routerList.length - 1].stationLng) / 2
      }
      // 设置中心点
      this.$refs.gMap.map.setCenter(centerPoint)
      // 延时操作
      setTimeout(() => {
        this.$refs.gMap.plannRoute(this.routerLists.pointList)
      }, 200)
      // this.$refs.gMap.map.setZoom(15)
      let pointDataList = []
      for (let i of this.routerLists.routerList) {
        let font
        if (i.font === 0) font = 'S'
        else if (i.font === this.routerLists.routerList.length - 1) font = 'G'
        else if (i.font !== 0 && i.font !== this.routerLists.routerList.length - 1) font = `G${i.font}`
        pointDataList.push({
          stationId: font,
          stationLng: i.stationLng,
          stationLat: i.stationLat,
          icon: font === 'S' ? STATION_ICON_FIRST : STATION_ICON
        })
      }
      this.$refs.gMap.pointListObj = pointDataList
      // 添加图标
      let imgSize = {width: 45, height: 60}
      // 图标里面的字体样式
      let labelAnchor = {width: 25, height: 53}
      this.markList = this.$refs.gMap.addMark(imgSize, 'route-label-class', labelAnchor)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-dialog {
  width: 65%;
  margin-top: 4%;
  .modal-body {
    padding-left: 40px;
    padding-right: 40px;
    .routeBody {
      height: 600px;
      padding: 10px;
      display: flex;
      .routeInfo {
        flex: 4;
        .detail {
          background-color: #efefef;
          height: 60px;
          border-top: 1px solid #fff;
          border-bottom: 1px solid #b9b9b8;
          position: relative;
          padding-right: 20px;
          .placeInfo-children-body {
            height: 100%;
            padding-left: 70px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .front {
              font-size: 1.5em;
              font-weight: 600;
              display: flex;
              justify-content: flex-start
            }
          }
          // 蓝色图标
          .radioClass {
            width: 40px;
            height: 40px;
            position: absolute;
            background-color: #5b91a9;
            margin: 10px 0 0 15px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            // 覆盖权重
            z-index: 3;
            .tagClass {
                color: white;
                font-size: 1.5em;
                font-weight: 100; // 字体粗度
            }
          }
          .line {
            position: absolute;
            left: 33px;
            width: 4px;
            background-color: #5b91a9;
            z-index: 2
          }
          // 正常竖线
          .lineClass {
            height: 80px;

          }
          // 图标第一个竖线
          .lineClassFirst {
            height: 45px;
          }
          // 图标末尾竖线
          .lineClassEnd {
            height: 45px;
            top: 45px;
          }
        }
      }
      .googleMap {
        flex: 7;
        padding-left: 10px;
        #routeInfoWinId {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.modal-header {
  padding: 15px;
  border-bottom: 0px solid #e5e5e5;
}
</style>



// WEBPACK FOOTER //
// src/components/RouteInfoWindow.vue